export default {
  CAMPAIGN_DASHBOARD: 'app.campaign.dashboard',
  CAMPAIGN_CREATOR: 'app.campaignsCreator',
  PROJECTS: 'app.campaigns',
  PROJECTS_ALL: 'app.campaigns.all',
  PROJECTS_ACTIVE: 'app.campaigns.active',
  PROJECTS_INACTIVE: 'app.campaigns.inactive',
  SCRIPTS_LIST: 'app.scripts',
  SCRIPT_CREATOR: 'app.script-creator',
  ORDER_NUMBER: 'app.orderNumber',
  ORDER_NUMBER_CONTACT: 'app.contactNumbers',
  ORDER_NUMBER_DEFAULT: 'app.orderNumberDefauls',
  PROJECT_IMPORT_HISTORY: 'app.campaign.import.history',
  GET_NUMBER: 'app.getNumber',
  BUY_NUMBER: 'app.buyNumber',
  FIRST_STEP_GET_NUMBER: 'blocked.getNumber',
  EXISTS_NUMBER: 'app.existsNumber',
  NUMBERS: 'app.numbers',
  NUMBERS_SETTINGS: 'app.numbers.settings',
  NUMBERS_CUSTOM: 'app.numbers.custom',
  WIDGET: 'app.widget',
  WIDGET_NO_SUPPORT: 'app.widget.noSupport',
  WIDGET_EXTENSION: 'app.widget.extension',
  USERS: 'app.users',
  USERS_DETAILS: 'app.users.id.details',
  ACCOUNT: 'app.account',
  MY_ACCOUNT: 'app.my-account',
  DEVELOPERS: 'app.developers',
  DEVELOPERS_API: 'app.developers.api',
  DEVELOPERS_WEBHOOKS: 'app.developers.webhooks',
  DEVELOPERS_WEBHOOKS_LIST: 'app.developers.webhooks.list',
  DEVELOPERS_WEBHOOKS_ADD: 'app.developers.webhooks.add',
  DEVELOPERS_WEBHOOKS_EDIT: 'app.developers.webhooks.edit',
  BLACKLIST: 'app.blacklist',
  RECORDS: 'app.records',
  RECORDS_DETAILS: 'app.recordsDetails',
  CONTACTS: 'app.contacts',
  IVR: 'app.ivr',
  GET_NEW_NUMBER: 'app.get-new-number'
};
